var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTodoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1259",
    "data-name": "Group 1259",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 33.36,
    viewBox: "0 0 35 33.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4adede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6172d6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M4.222,33.36A4.226,4.226,0,0,1,0,29.138V7.5A4.227,4.227,0,0,1,4.222,3.282H8.206V.728A.727.727,0,0,1,8.933,0H26.069A.728.728,0,0,1,26.8.728V3.282h3.984A4.226,4.226,0,0,1,35,7.5V29.138a4.226,4.226,0,0,1-4.221,4.222ZM2.18,7.976V28.667A2.516,2.516,0,0,0,4.694,31.18H30.308a2.516,2.516,0,0,0,2.513-2.513V7.976a2.516,2.516,0,0,0-2.513-2.513H26.8V8.018a.727.727,0,0,1-.727.727H8.933a.727.727,0,0,1-.727-.727V5.463H4.694A2.516,2.516,0,0,0,2.18,7.976Zm8.206-1.411h14.23V2.18H10.386ZM6.83,27.043,5.062,25.276a.724.724,0,0,1,0-1.028l.514-.514a.727.727,0,0,1,1.027,0l.74.741,2.382-2.381a.728.728,0,0,1,1.027,0l.514.515a.724.724,0,0,1,0,1.027l-3.409,3.41a.726.726,0,0,1-1.028,0ZM15.992,25.7a.693.693,0,0,1-.675-.724v-.73a.694.694,0,0,1,.675-.725H28.854a.7.7,0,0,1,.677.725v.73a.694.694,0,0,1-.677.724ZM6.83,22.12,5.062,20.353a.724.724,0,0,1,0-1.028l.514-.514a.727.727,0,0,1,1.027,0l.74.741L9.726,17.17a.728.728,0,0,1,1.027,0l.514.515a.724.724,0,0,1,0,1.027l-3.409,3.41a.726.726,0,0,1-1.028,0Zm9.162-1.342a.693.693,0,0,1-.675-.724v-.73a.694.694,0,0,1,.675-.725H28.854a.7.7,0,0,1,.677.725v.73a.7.7,0,0,1-.677.724ZM6.83,17.2,5.062,15.43a.724.724,0,0,1,0-1.028l.514-.514a.727.727,0,0,1,1.027,0l.74.741,2.382-2.381a.728.728,0,0,1,1.027,0l.514.515a.724.724,0,0,1,0,1.027L7.857,17.2a.726.726,0,0,1-1.028,0Zm9.162-1.342a.693.693,0,0,1-.675-.724V14.4a.694.694,0,0,1,.675-.725H28.854a.7.7,0,0,1,.677.725v.73a.7.7,0,0,1-.677.724Z",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodoIcon);
export default __webpack_public_path__ + "static/media/Todo_icon.7e91e74e61be25a9c8385e46169ea01c.svg";
export { ForwardRef as ReactComponent };